<app-header></app-header>

<div class="loader-container" *ngIf="loadingSequence">
  <div class="three-strings">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="processing-text">Processing...</div>
</div>

<section>
  <div class="container" #scrollContainer>   
      <div class="text-center">
        <div class="forgotdiv">         
            <h1 class="text-center">Personal and Organizational Details</h1>       
            <form [formGroup]="form">
              <span class="text-center"><label style="align-self:center;color:black;width:50%; font-family:Arial"><b>[ UDYAM Registration Number: {{udyamnumber}} ]</b></label></span>
              <div class="card mt-4">
                <div class="card-header text-start">
                  <h2>Personal Details</h2>
                </div>
                <div class="card-body">
                  <div class="row text-start">
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Name of Enterprise <span class="text-danger">*</span></label>
                      <input type="text" autocomplete="off" id="txtNameOfEnterprise" class="form-control" formControlName="nameOfEnterprise" maxlength="100"
                              (blur)="removeExtraSpaces('nameOfEnterprise')"
                             placeholder="Enterprise Name">
                      <div *ngIf="f['nameOfEnterprise'].touched && f['nameOfEnterprise'].invalid" class="alert alert-danger">
                        <div *ngIf="f['nameOfEnterprise'].errors && f['nameOfEnterprise'].errors['required']">
                          Enterprise name is required
                        </div>
                        <div *ngIf="f['nameOfEnterprise'].errors && f['nameOfEnterprise'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['nameOfEnterprise'].errors && f['nameOfEnterprise'].errors['maxlength']">
                          Maximum length should be 100 characters
                        </div>
                        <div *ngIf="f['nameOfEnterprise'].errors && f['nameOfEnterprise'].errors['pattern']">
                          Enterprise Name should be characters
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Entrepreneur's Name <span class="text-danger">*</span></label>
                      <input type="text" autocomplete="off" id="txtName" class="form-control" formControlName="name"
                             placeholder="Owner's Name">
                      <div *ngIf="f['name'].touched && f['name'].invalid" class="alert alert-danger">
                        <div *ngIf="f['name'].errors && f['name'].errors['required']">
                          Owner's Name is required
                        </div>
                        <div *ngIf="f['name'].errors && f['name'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['name'].errors && f['name'].errors['maxlength']">
                          Maximum length should be 100 characters
                        </div>
                        <div *ngIf="f['name'].errors && f['name'].errors['pattern']">
                          Name should not contain digits or special characters
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Type of Enterprise <span class="text-danger">*</span></label>
                      <!--<select id="txtTypeOfEnterprise" class="form-select" formControlName="typeOfEnterprise">
                        <option value="" disabled selected>Select Enterprise Type</option>
                        <option *ngFor="let type of enterpriseType" [value]="type.id">
                          {{ type.name }}
                        </option>
                      </select>-->

                      <ng-select [items]="enterpriseType"
                                 bindLabel="name"
                                 bindValue="id"
                                 formControlName="typeOfEnterprise"
                                 [searchable]="true"
                                 placeholder="--select--"
                                 appendTo="body">
                      </ng-select>
                      <div *ngIf="f['typeOfEnterprise'].touched && f['typeOfEnterprise'].invalid" class="alert alert-danger">
                        <div *ngIf="f['typeOfEnterprise'].errors && f['typeOfEnterprise'].errors['required']">
                          Enterprise Type is required
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Type of Organization <span class="text-danger">*</span></label>
                      <!--<select id="txttypeofOrganization" class="form-select" formControlName="typeofOrganization">
                        <option value="" disabled selected>Select Organization Type</option>
                        <option *ngFor="let type of organizationType" [value]="type.organizationTypeId">
                          {{ type.organizationTypeName }}
                        </option>
                      </select>-->
                      <ng-select [items]="organizationType"
                                 bindLabel="organizationTypeName"
                                 bindValue="organizationTypeId"
                                 formControlName="typeofOrganization"
                                 [searchable]="true"
                                 placeholder="--select--"
                                 appendTo="body">
                      </ng-select>
                      <div *ngIf="f['typeofOrganization'].touched && f['typeofOrganization'].invalid" class="alert alert-danger">
                        <div *ngIf="f['typeofOrganization'].errors && f['typeofOrganization'].errors['required']">
                          Organization Type is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row text-start">
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Mobile Number as per Udyam Registration <span class="text-danger">*</span></label>
                      <input type="text" autocomplete="off" id="txtOwnersMobileNumber" class="form-control" (keypress)="numberOnly($event)"
                             formControlName="ownersMobileNumber" placeholder="Owner mobile Number" maxlength="10">
                      <div *ngIf="f['ownersMobileNumber'].touched && f['ownersMobileNumber'].invalid" class="alert alert-danger">
                        <div *ngIf="f['ownersMobileNumber'].errors && f['ownersMobileNumber'].errors['required']">
                          Owner's mobile Number is required
                        </div>
                        <div *ngIf="f['ownersMobileNumber'].errors && f['ownersMobileNumber'].errors['minlength']">
                          Length should be 3 characters
                        </div>
                        <div *ngIf="f['ownersMobileNumber'].errors && f['ownersMobileNumber'].errors['pattern']">
                          Mobile number should be 10 digits only, first digit should be non-zero
                        </div>
                      </div>
                      <input type="checkbox" formControlName="isWhatsAppEnabled" (change)="onWhatsAppChange()" class="form-check-input">
                      Is this a WhatsApp number?
                    </div>
                    <div class="col-md-3 mb-2" *ngIf="!isWhatsAppSelected">
                      <label class="nowrap">Enter WhatsApp Number <span class="text-danger">*</span></label>
                      <input type="text" autocomplete="off" id="txtalternateContactNumber" class="form-control" (keypress)="numberOnly($event)"
                             formControlName="alternateContactNumber" placeholder="WhatsApp Number" maxlength="10">
                      <div *ngIf="f['alternateContactNumber'].touched && f['alternateContactNumber'].invalid" class="alert alert-danger">
                        <div *ngIf="f['alternateContactNumber'].errors && f['alternateContactNumber'].errors['required']">
                          Enter WhatsApp number or check Mobile Number as per Udyam as Whatsapp number.
                        </div>
                        <div *ngIf="f['alternateContactNumber'].errors?.['pattern']">
                          Enter Valid mobile number.Mobile number should be 10 digits only, first digit should be non-zero
                        </div>
                      </div>
                      <!--<div *ngIf="alternateContactNumberErrors && alternateContactNumberErrors['required']" class="alert alert-danger">
            <div *ngIf="alternateContactNumberErrors['required']">
              Enter WhatsApp number or check Mobile Number as per Udyam as Whatsapp number.
            </div>
          </div>-->
                    </div>
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Gender as per Udyam Registration <span class="text-danger">*</span></label><br>
                      <input type="radio" id="rdbtnmale" value="Male" formControlName="gender" class="form-check-input">Male
                      <input type="radio" id="rdbtnfemale" value="Female" formControlName="gender" class="form-check-input">Female
                      <input type="radio" id="rdbtnother" value="Other" formControlName="gender" class="form-check-input">Other
                      <div *ngIf="f['gender'].touched && f['gender'].invalid" class="alert alert-danger">
                        <div *ngIf="f['gender'].errors && f['gender'].errors['required']">
                          Gender is required
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Social category as per Udyam Registration <span class="text-danger">*</span></label>
                      <!--<select id="txtsocialcategory" class="form-select" formControlName="socialCategory">
                        <option value="" disabled selected>Select Social Category</option>
                        <option *ngFor="let type of socialCategory" [value]="type.socialCategoryId">
                          {{ type.socialCategoryName }}
                        </option>
                      </select>-->
                      <ng-select [items]="socialCategory"
                                 bindLabel="socialCategoryName"
                                 bindValue="socialCategoryId"
                                 formControlName="socialCategory"
                                 [searchable]="true"
                                 placeholder="--select--"
                                 appendTo="body">
                      </ng-select>
                      <div *ngIf="f['socialCategory'].touched && f['socialCategory'].invalid" class="alert alert-danger">
                        <div *ngIf="f['socialCategory'].errors && f['socialCategory'].errors['required']">
                          Social Category is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row text-start">
                    <div class="col-md-3 mb-2">
                      <label>Specially Abled (PwD?)  <span class="text-danger">*</span></label>
                      <br />
                      <input type="radio" id="rdbtndisabled" [value]="true" formControlName="areYouAPersonWithDisabilities" class="form-check-input">Yes
                      <input type="radio" id="rdbtndisabled" [value]="false" formControlName="areYouAPersonWithDisabilities" class="form-check-input">No
                      <div *ngIf="f['areYouAPersonWithDisabilities'].touched && f['areYouAPersonWithDisabilities'].invalid" class="alert alert-danger">
                        <div *ngIf="f['areYouAPersonWithDisabilities'].errors && f['areYouAPersonWithDisabilities'].errors['required']">
                          Please select if person with Disability or not
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mt-4">
                <div class="card-header text-start"><h2>NIC Details</h2></div>
                <div class="card-body">
                  <div class="row text-start">
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">NIC Code <span class="text-danger">*</span></label>
                      <!--<select id="txtNICCode" class="form-select" formControlName="nicCode" (change)="onNICCodeChange($event)">
                        <option value="" disabled selected>Select NIC Code</option>
                        <option *ngFor="let type of niclist" [value]="type.nicCode">
                          {{ type.nicCode  }} ({{ type.subClassName  }})
                        </option>
                      </select>-->
                    <ng-select [items]="niclist"
                               bindLabel="nicCode (subClassName)"
                               bindValue="nicCode"
                               formControlName="nicCode"
                               [searchable]="true"
                               placeholder="--select--"
                               (change)="onNICCodeChange($event)"
                               appendTo="body">
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.nicCode }} ({{ item.subClassName }})
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.nicCode }} ({{ item.subClassName }})
                      </ng-template>
                    </ng-select>
                      <div *ngIf="nicEntries.length === 0" style="color: red;">
                        At least one NIC code must be added.
                      </div>
                    </div>
                    <div class="col-md-3 mb-2">
                      <button class="btn btn-primary mt-4" (click)="addNIC()" [disabled]="disableRemove">Add</button>
                      <button type="button" class="btn btn-secondary mt-4" (click)="generatePDF()">
                        Show All NIC Data
                      </button>
                    </div>

                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th class="text-center">Sr. No.</th>
                          <th class="text-center">NIC Code</th>
                          <th class="text-center">Sector</th>
                          <th class="text-center">Division</th>
                          <th class="text-center">Group</th>
                          <th class="text-center">Class</th>
                          <th class="text-center">Sub Class</th>
                          <th class="text-center" style="width:120px">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let entry of nicEntries; let i = index">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="text-center">{{ entry.nicCode }}</td>
                          <td class="text-center">{{ entry.sector }}</td>
                          <td class="text-center">{{ entry.divisionDescription }}</td>
                          <td class="text-center">{{ entry.groupDescription }}</td>
                          <td class="text-center">{{ entry.class }}</td>
                          <td class="text-center">{{ entry.subClass }}</td>
                          <td class="text-center">
                            <button class="btn btn-danger btn-sm" (click)="openConfirmationDialog('nicEntry', i)" [disabled]="disableRemove"><i class="bi bi-trash"></i> Remove</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="card mt-4">
                <div class="card-header text-start"> <h2>Enterprise Details</h2></div>
                <div class="card-body">
                  <!--<div class="row text-start">
  <div class="col-md-3 mb-2">
    <label>Are you an Exporter <span class="text-danger">*</span></label>
    <br />
    <input type="radio" id="rdbtnexporterYes" [value]="true" formControlName="areYouAnExporter" class="form-check-input"> Yes
    <input type="radio" id="rdbtnexporterNo" [value]="false" formControlName="areYouAnExporter" class="form-check-input"> No
    <div *ngIf="f['areYouAnExporter'].touched && f['areYouAnExporter'].invalid" class="alert alert-danger">
      <div *ngIf="f['areYouAnExporter'].errors && f['areYouAnExporter'].errors['required']">
        Please select if you are an exporter or not
      </div>
    </div>
  </div>

  <div class="col" *ngIf="showIECField">
    <label for="txtIEC">Enter your Importer - Exporter Code (IEC)</label>
    <br />
    <input type="text" autocomplete="off" id="txtIEC" class="form-control" (keypress)="numberOnly($event)"
           formControlName="iec" placeholder="IEC" required maxlength="10" />-->
                  <!-- Validation error message for IEC field -->
                  <!--<div *ngIf="form.get('iec')?.invalid && (form.get('iec')?.touched || form.get('iec')?.dirty)" class="alert alert-danger">-->
                  <!-- IEC required validation -->
                  <!--<div *ngIf="form.get('iec')?.hasError('required')">
    IEC is required when you are an exporter.
  </div>-->
                  <!-- IEC pattern validation -->
                  <!--<div *ngIf="form.get('iec')?.hasError('pattern')">
    Please enter a valid 10 digit IEC code.
  </div>-->
                  <!-- IEC min/max length validation -->
                  <!--<div *ngIf="form.get('iec')?.hasError('minlength')">
          Minimum 10 digit IEC code should be added.
        </div>
        <div *ngIf="form.get('iec')?.hasError('maxlength')">
          Maximum 10 digit IEC code should be added.
        </div>
      </div>
    </div>
  </div>-->
                  <div class="row text-start mb-3">
                    <div class="col">
                      <label class="nowrap">Official Address of enterprise <span class="text-danger">*</span></label>
                      <input type="text" autocomplete="off" id="txtOfficialAddressOfEnterprise" class="form-control"
                             formControlName="officialAddressOfEnterprise" placeholder="Official Address of enterprise">
                      <div *ngIf="f['officialAddressOfEnterprise'].touched && f['officialAddressOfEnterprise'].invalid" class="alert alert-danger">
                        <div *ngIf="f['officialAddressOfEnterprise'].errors && f['officialAddressOfEnterprise'].errors['required']">
                          Official Address of enterprise is required
                        </div>
                        <div *ngIf="f['officialAddressOfEnterprise'].errors && f['officialAddressOfEnterprise'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['officialAddressOfEnterprise'].errors && f['officialAddressOfEnterprise'].errors['maxlength']">
                          Maximum length should be 255 characters
                        </div>
                        <div *ngIf="f['officialAddressOfEnterprise'].errors && f['officialAddressOfEnterprise'].errors['pattern']">
                          Official Address is invalid
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row text-start">
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">State <span class="text-danger">*</span></label>
                      <select id="txtState" class="form-select" formControlName="stateId">
                        <option value="" disabled>Select State</option>
                        <option *ngFor="let type of maharashtraState" [value]="type.stateCode">
                          {{ type.StateName }}
                        </option>
                      </select>
                      <div *ngIf="f['stateId'].touched && f['stateId'].invalid" class="alert alert-danger">
                        <div *ngIf="f['stateId'].errors && f['stateId'].errors['required']">
                          State is required
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 mb-2">
                      <label class="nowrap">District <span class="text-danger">*</span></label>
                      <!-- Dropdown for selecting a district -->
                      <!--<select id="txtDistrict" class="form-select" formControlName="districtId" (change)="GetBlocks($event)">-->
                        <!-- Default "Select District" option -->
                        <!--<option value="" disabled>Select District</option>
                        <option *ngFor="let district of districtsBasedOnState" [value]="district.districtCode">
                          {{ district.districtName }}
                        </option>
                      </select>-->

                      <ng-select [items]="districtsBasedOnState"
                                 bindLabel="districtName"
                                 bindValue="districtCode"
                                 formControlName="districtId"
                                 [searchable]="true"
                                 placeholder="--select--"
                                 (change)="GetBlocks($event)" appendTo="body">
                      </ng-select>

                      <!-- Validation error message for district selection -->
                      <div *ngIf="f['districtId'].touched && f['districtId'].invalid" class="alert alert-danger">
                        <div *ngIf="f['districtId'].errors && f['districtId'].errors['required']">
                          District is required
                        </div>
                      </div>
                    </div>


                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Block </label>
                      <!--<select id="txtBlock" class="form-select" formControlName="block">
                        <option value="" disabled selected>Select Block</option>
                        <option *ngFor="let type of blocksBasedonDistricts" [value]="type.blockId">
                          {{ type.blockName }}
                        </option>
                      </select>-->

                      <ng-select [items]="blocksBasedonDistricts"
                                 bindLabel="blockName"
                                 bindValue="blockId"
                                 formControlName="block"
                                 [searchable]="true"
                                 placeholder="--select--"
                                 appendTo="body">
                      </ng-select>
                      <div *ngIf="f['block'].touched && f['block'].invalid" class="alert alert-danger">
                        <div *ngIf="f['block'].errors && f['block'].errors['required']">
                          Block is required
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 mb-2">
                      <label class="nowrap">City <span class="text-danger">*</span></label>
                      <input type="text" autocomplete="off" id="txtcity" class="form-control"
                             formControlName="city" placeholder="City">
                      <div *ngIf="f['city'].touched && f['city'].invalid" class="alert alert-danger">
                        <div *ngIf="f['city'].errors && f['city'].errors['required']">
                          City is required
                        </div>
                        <div *ngIf="f['city'].errors && f['city'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['city'].errors && f['city'].errors['maxlength']">
                          Length should be 50 characters
                        </div>
                        <div *ngIf="f['city'].errors && f['city'].errors['pattern']">
                          Please enter city in characters only
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Pincode<span class="text-danger">*</span></label>
                      <input type="text" autocomplete="off" id="txtpin" class="form-control" (keypress)="numberOnly($event)"
                             formControlName="pin" placeholder="Pin Code" maxlength="6">
                      <div *ngIf="f['pin'].touched && f['pin'].invalid" class="alert alert-danger">
                        <div *ngIf="f['pin'].errors && f['pin'].errors['required']">
                          Pin is required
                        </div>
                        <div *ngIf="f['pin'].errors && f['pin'].errors['minlength']">
                          Minimum length should be 6 characters
                        </div>
                        <div *ngIf="f['pin'].errors && f['pin'].errors['maxlength']">
                          Length should be 6 characters
                        </div>
                        <div *ngIf="f['pin'].errors && f['pin'].errors['pattern']">
                          Please enter 6 digit pin that starts with 4
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">DIC <span class="text-danger">*</span></label>
                      <input type="text" autocomplete="off" id="txtDIC" class="form-control" formControlName="dic"
                             placeholder="DIC">
                      <div *ngIf="f['dic'].touched && f['dic'].invalid" class="alert alert-danger">
                        <div *ngIf="f['dic'].errors && f['dic'].errors['required']">
                          DIC is required
                        </div>
                        <div *ngIf="f['dic'].errors && f['dic'].errors['minlength']">
                          Minimum length should be 3 characters
                        </div>
                        <div *ngIf="f['dic'].errors && f['dic'].errors['maxlength']">
                          Length should be 50 characters
                        </div>
                        <div *ngIf="f['dic'].errors && f['dic'].errors['pattern']">
                          Please insert valid DIC
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row text-start">
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Date of Incorporation</label>
                      <input type="date" autocomplete="off" id="txtDateOfIncorporation" class="form-control"
                             formControlName="dateOfIncorporation" [max]="maxDate" (keydown)="blockManualInput($event)">
                    </div>
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Date of Commencement</label>
                      <input type="date" autocomplete="off" id="txtDateOfCommencement" class="form-control"
                             formControlName="dateOfCommencement" [max]="maxDate" (keydown)="blockManualInput($event)">
                    </div>

                    
                    <div class="col-md-3 mb-2">
                      <label class="nowrap">Investment Cost</label>
                      <input type="text" autocomplete="off" id="txtInvestmentCost" class="form-control" (keypress)="numberOnly($event)"
                             formControlName="investmentCost" placeholder="Investment Cost" maxlength="10">
                    </div>
                  </div>
                  <div class="row text-start">
                    <div class="col-md-6 mb-2">
                      <label class="nowrap">Major Activity <span class="text-danger">*</span></label> <br>
                      <input type="radio" id="rdbtnmanufacturing" value="Manufacturing" formControlName="majorActivity" class="form-check-input">Manufacturing
                      <input type="radio" id="rdbtnservices" value="Services" formControlName="majorActivity" class="form-check-input">Services
                      <input type="radio" id="rdbtntrading" value="Trading" formControlName="majorActivity" class="form-check-input">Trading
                      <div *ngIf="f['majorActivity'].touched && f['majorActivity'].invalid" class="alert alert-danger">
                        <div *ngIf="f['majorActivity'].errors && f['majorActivity'].errors['required']">
                          Major Activity is required
                        </div>
                      </div>
                    </div>
                  </div>

                  </div>
                </div>

              <div class="card mt-4">
                <div class="card-header text-start"><h2>Plant and Location Details</h2></div>
                <div class="card-body">
                  <div class="row text-start">
                    <div class="col-md-5 mb-2">
                      <label class="nowrap" for="plantUnitName">Plant/Unit Name: <span class="text-danger">*</span></label>
                      <input id="plantUnitName" class="form-control" formControlName="plantUnitName" placeholder="Plant/Unit Name" />
                      <div *ngIf="form.get('plantUnitName')?.invalid && form.get('plantUnitName')?.touched" class="alert alert-danger">                        
                        <ng-container *ngIf="form.get('plantUnitName')?.errors?.['pattern']">
                          Plant unit is not in the correct format.
                        </ng-container>
                        <ng-container *ngIf="form.get('plantUnitName')?.errors?.['minlength']">
                          Minimum length should be 3 characters
                        </ng-container>
                        <ng-container *ngIf="form.get('plantUnitName')?.errors?.['maxlength']">
                          Length should be 100 characters
                        </ng-container>
                      </div>
                    </div>
                    <div class="col-md-5 mb-2">
                      <label class="nowrap" for="locationOfPlantUnit">Address/Location of plant/unit: <span class="text-danger">*</span></label>
                      <input id="locationOfPlantUnit" class="form-control" formControlName="locationOfPlantUnit" placeholder="Location" />
                      <div *ngIf="form.get('locationOfPlantUnit')?.invalid && form.get('locationOfPlantUnit')?.touched" class="alert alert-danger">                        
                        <ng-container *ngIf="form.get('locationOfPlantUnit')?.errors?.['pattern']">
                          Location is not in the correct format.
                        </ng-container>
                        <ng-container *ngIf="form.get('locationOfPlantUnit')?.errors?.['minlength']">
                          Minimum length should be 3 characters
                        </ng-container>
                        <ng-container *ngIf="form.get('locationOfPlantUnit')?.errors?.['maxlength']">
                          Length should be 100 characters
                        </ng-container>
                      </div>
                    </div>
                    <div class="col-md-2 mb-2">
                      <button (click)="addPlantUnit()" class="btn btn-primary mt-4" [disabled]="disableRemove">Add</button>
                    </div>
                  </div>


                  <!--<div *ngIf="plantUnits.length === 0" style="color: red;" class="text-start">
                    At least one plant unit and location must be added.
                  </div>-->

                  <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          <th>Plant Unit</th>
                          <th>Location</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="plantUnits && plantUnits.length > 0; else noPlantData">
                          <tr *ngFor="let unit of plantUnits; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ unit.name }}</td>
                            <td>{{ unit.location }}</td>
                            <td>
                              <button (click)="openConfirmationDialog('plantUnit', i)" class="btn btn-danger btn-sm" [disabled]="disableRemove"><i class="bi bi-trash"></i> Remove</button>
                            </td>
                          </tr>
                        </ng-container>
                        <!-- No Data Found -->
                        <ng-template #noPlantData>
                          <tr>
                            <td colspan="9" class="text-center">N/A</td>
                          </tr>
                        </ng-template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="card mt-4">
                <div class="card-header text-start"> <h2>Interests Details</h2></div>
                <div class="card-body">
                  
                  <div class="row text-start mb-3">
                    <div class="col-6">
                      <label class="nowrap">Select the Component(s) of your Interest:</label>
                      <div class="interest-selection-box">
                        <div *ngFor="let interest of filteredInterests" class="form-check">
                          <input type="checkbox"
                                 class="form-check-input"
                                 [checked]="interest.selected"
                                 (change)="toggleInterestSelection(interest, $event)" />
                          <label class="form-check-label">
                            {{ interest.interestName }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="col-1 text-center">
                      <button class="btn btn-sm btn-primary my-2" (click)="moveSelectedToRight()">
                        <i class="bi bi-arrow-right"></i>
                      </button>
                      <button class="btn btn-sm btn-primary my-2" (click)="moveSelectedToLeft()">
                        <i class="bi bi-arrow-left"></i>
                      </button>
                    </div>

                    <div class="col-5">
                      <label class="nowrap">Selected Interests</label>
                      <div class="selected-interests-box">
                        <div *ngFor="let selectedInterest of selectedInterests" class="form-check">
                          <input type="checkbox"
                                 class="form-check-input"
                                 [checked]="selectedInterest.selected"
                                 (change)="toggleInterestSelection(selectedInterest, $event)" />
                          <label class="form-check-label">
                            {{ selectedInterest.interestName }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedInterests.length === 0" style="color: red;" class="text-start">
                    At least one interest must be added.
                  </div>

                </div>
              </div>

              <div class="card mt-4">
                <div class="card-header text-start"> <h2>Upload Udyam Certificate</h2></div>
                <div class="card-body">
                  <div class="row text-start">
                    <div class="col-md-4 mb-2">
                      <label for="udyamCertificate">Upload Udyam Certificate (PDF, max 10 MB): </label>                      
                    </div>                   
                    <div class="col-md-4 mb-2">
                      <input type="file"
                             id="udyamCertificate"
                             (change)="onUdyamFileChange($event)"
                             accept=".pdf"
                             formControlName="udyamCertificate"
                             class="form-control" />
                      <div *ngIf="form.controls['udyamCertificate'].invalid && form.controls['udyamCertificate'].touched"
                           class="alert alert-danger">
                        Upload the Udyam Certificate.
                      </div>
                      <div *ngIf="uploadUdyamError" class="alert alert-danger">{{ uploadUdyamError }}</div>
                      <div *ngIf="form.get('udyamCertificate')?.value" class="mt-2">
                        <strong>Uploaded File:</strong> {{ form.get('udyamCertificate')?.value }}
                      </div>
                    </div>
                    <div style="color: red;" class="text-start">
                      <label>Note : File Name should not contain special characters except -/./_</label>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          <th>Document Name</th>
                          <th>File</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        
                        <tr>
                          <td>1</td>
                          <td>Udyam Certificate</td>
                          <td>{{ form.get('udyamCertificate')?.value || 'No file uploaded' }}</td>
                          <td>
                            <!-- Show the remove button only if a file is selected -->
                            <button *ngIf="form.get('udyamCertificate')?.value" (click)="removeUdyamCertificate()" class="btn btn-danger btn-sm">
                              <i class="bi bi-trash"></i> Remove
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="card mt-4">
                <div class="card-header text-start"><h2>Enter Supporting Documents (if any):</h2></div>
                <div class="card-body">

                  <!-- Form array for dynamic document entries -->
                  <div formArrayName="documents">
                    <div *ngFor="let doc of documents.controls; let i = index" [formGroupName]="i">
                      <div class="row text-start">
                        <!-- Document Name -->
                        <div class="col-md-4 mb-2">
                          <label class="nowrap" for="docName{{ i }}">
                            Document Name:
                            <!--<span class="text-danger">*</span>-->
                          </label>
                          <input id="docName{{ i }}" class="form-control" formControlName="name" placeholder="Enter Document Name" />

                          <div *ngIf="doc.get('name')?.invalid && doc.get('name')?.touched" class="alert alert-danger">
                            Please enter the document name.
                          </div>
                          <div *ngIf="doc.get('name')?.invalid && doc.get('name')?.errors?.['pattern'] " class="alert alert-danger">
                            Document name should not contian special characters other than _/-
                          </div>
                        </div>

                        <!-- File Upload -->
                        <div class="col-md-4 mb-2">
                          <label class="nowrap" for="docFile{{ i }}">Upload File (PDF, max 10 MB):
                          <!--<span class="text-danger">*</span>-->
                          </label>
                          <input type="file" id="docFile{{ i }}" (change)="onFileChange($event, i)" accept=".pdf" class="form-control" />
                          <div *ngIf="doc.get('file')?.invalid && doc.get('file')?.touched" class="alert alert-danger">
                            Invalid File name or File Type.
                          </div>
                          <div *ngIf="form.get('udyamCertificate')?.value" class="mt-2">
                            <strong>Uploaded File:</strong> {{ doc.get('file')?.value?.name  }}
                          </div>
                        </div>

                        <!-- Remove Button -->
                        <div class="col-md-4 mb-2">
                          <button type="button" class="btn btn-danger btn-sm mt-md-4" (click)="removeDocument(i)"><i class="bi bi-trash"></i> Remove</button>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="text-start">
                    <div style="color: red;" class="text-start">
                      <label>Note : Document Name should not contain special characters except -/./_</label>
                    </div>
                    <!-- Add More Documents button, disabled if 5 documents are added -->
                    <button type="button" class="btn btn-primary text-start" (click)="addMoreDocuments()" [disabled]="documents.length >= 5">Add More</button>
                  </div>
                  <br />
                  <!-- Display error message if any -->
                  <div *ngIf="uploadError" class="alert alert-danger">
                    {{ uploadError }}
                  </div>

                </div>
              </div>

              <div class="card mt-4">
                <div class="card-header text-start"><h2>Uploaded Documents:</h2></div>
                <div class="card-body">
                  <!--Table to display uploaded documents-->

                  <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          <th>Document Name</th>
                          <th>File</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let doc of documents.controls; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>{{ doc.get('name')?.value || 'N/A' }}</td>
                          <td>{{ doc.get('file')?.value?.name || 'No file selected' }}</td>
                          <td>
                            <button (click)="removeDocument(i)" class="btn btn-danger btn-sm"><i class="bi bi-trash"></i> Remove</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="text-center mt-2">
                    <button id="btnsave" type="submit" (click)="SendtoPreview(form)" class="btn btn-secondary">Preview</button>
                    <!--<button id="btncancel" type="reset" (click)="onReset()" class="btn btn-danger">Cancel</button>-->
                    <!--<button id="btncancel" type="reset" class="btn btn-danger" [routerLink]="'/login'">Cancel</button>-->
                    <button id="btncancel" type="button" class="btn btn-danger" (click)="onCancel()">Cancel </button>
                       
                  </div>
                </div>
              </div>




            </form>
        </div>
      </div>
   
  </div>
</section>
<app-footer></app-footer>
